import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/(app)/kirei-tube/[slug]/page.tsx");
